/* tslint:disable */

/**
 */
export class ViewStudyEquipmentForStudy {
    ID_EQUIP?: number;
    EQUIP_NAME?: string;
    EQUIP_STATUS?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-study-equipment-for-study.ts